import { makeDraggable } from '@utilities/dom';

export default class HorizontalScrollPlugin {
  dom: HTMLElement;
  constructor(dom: HTMLElement) {
    this.dom = dom;
  }

  init() {
    makeDraggable(this.dom);

    this.scrollToActive();
  }

  scrollToActive() {
    const activeEl = this.dom.querySelector<HTMLElement>('.active');
    if (!activeEl) return;

    const scrollLeft = activeEl.offsetLeft - (this.dom.offsetWidth - activeEl.offsetWidth) / 2;
    this.dom.scrollTo({ left: scrollLeft, behavior: 'instant' });
  }
}
